import type { DevScenario } from '@arya/shared/domain';
import type { MockApiErrorBody } from '@arya/shared/msw-cloudflare';
import { devScenarioRequest } from '@arya/shared/msw-cloudflare';

import { http, HttpResponse } from 'msw';

export const INVEST_SOURCE_OF_FUNDS_REQUIRED_SCENARIO: DevScenario = {
  name: 'invest-403',
  group: 'Invest',
  title: 'Source of funds proof',
  description: 'Confirming an investment answers 403: the dialog asks for proof of source of funds.',
  screen: '/market/projects/2?invest=2500',
};

export const investSourceOfFundsRequiredHandler = http.all(
  devScenarioRequest(
    { method: 'POST', path: '/api/market/projects/:projectId/invest' },
    INVEST_SOURCE_OF_FUNDS_REQUIRED_SCENARIO
  ),
  () => {
    const body: MockApiErrorBody = {
      error: {
        message: 'Proof of source of funds is required before this action',
        data: { code: 'PROOF_OF_SOURCE_OF_FUNDS_REQUIRED', reason: 'THRESHOLD', sourceOfIncomeId: 'soi-1' },
      },
    };
    return HttpResponse.json(body, { status: 403 });
  }
);
